{
 "note": "made by tools/make-ride-coach.py from assets/ride; do not edit",
 "image": "/sprites/ride-coach.png",
 "door_image": "/sprites/ride-door.png",
 "size": [
  1983,
  793
 ],
 "aspect": 2.5006,
 "windows": [
  {
   "x": 0.0484,
   "y": 0.2421,
   "w": 0.2461,
   "h": 0.2711
  },
  {
   "x": 0.7065,
   "y": 0.2421,
   "w": 0.2451,
   "h": 0.2711
  }
 ],
 "door": {
  "x": 0.408,
  "y": 0.1185,
  "w": 0.1836,
  "h": 0.6608,
  "split": 0.5,
  "_": "leaves meet at the middle of this box; slide each one its own half-width to pocket it"
 },
 "panel": {
  "x": 0.3959,
  "y": 0.087,
  "w": 0.2093,
  "h": 0.0315
 },
 "floor": 0.8411,
 "person": 0.593,
 "_person": "a 1.75 m body as a fraction of the scene height, from a 1.95 m door opening"
}
